import React from "react";
import { get } from "lodash";
import Papa from "papaparse";

import "./table.m.css";

const Column = ({ cell }) => <td styleName="table-element-cell">{cell}</td>;

const Row = ({ row }) => {
  const childrenRows = row.map((cell, index) => <Column cell={cell} key={index} />);

  return <tr styleName="table-element-row">{childrenRows}</tr>;
};

const StoryElementTable = ({ storyElement }) => {
  const tableHasHeader = get(storyElement, ["metadata", "has-header"], false);
  const parsedData = Papa.parse(storyElement.data.content, { newline: "\r\n" }).data;
  const tableData = parsedData.slice(Number(tableHasHeader));
  const children = tableData.map((row, index) => <Row row={row} key={index} />);

  return (
    <table styleName="story-table-element" key={storyElement.id}>
      {tableHasHeader && (
        <thead styleName="table-element-header">
          <tr styleName="table-element-row">
            {parsedData[0].map((cell) => (
              <th styleName="table-header-cell">{cell}</th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>{children}</tbody>
    </table>
  );
};

export default StoryElementTable;
